import { Navigate, Route, Routes } from 'react-router-dom';
import Login from '../Pages/Store/Login/Login';
import Dashboard from '../Pages/Store/Dashboard/Dashboard';
import Unit from '../Pages/Store/StoreMaster/Unit/Unit';
import ManageUnit from '../Pages/Store/StoreMaster/Unit/ManageUnit';
import Category from '../Pages/Store/StoreMaster/Category/Category';
import ManageCategory from '../Pages/Store/StoreMaster/Category/ManageCategory';
import Transport from '../Pages/Store/StoreMaster/Transport/Transport';
import ManageTransport from '../Pages/Store/StoreMaster/Transport/ManageTransport';
import Location from '../Pages/Store/StoreMaster/InventoryLocation/Location';
import ManageLocation from '../Pages/Store/StoreMaster/InventoryLocation/ManageLocation';
import Project from '../Pages/Store/Project/Project';
import ManageProject from '../Pages/Store/Project/ManageProject';
import PartyGroup from '../Pages/Store/StoreMaster/PartyGroup/PartyGroup';
import ManagePartyGroup from '../Pages/Store/StoreMaster/PartyGroup/ManagePartyGroup';
import Party from '../Pages/Store/Party/Party';
import ManageParty from '../Pages/Store/Party/ManageParty';
import ForgetPassword from '../Pages/Store/Login/ForgetPassword';
import Otp from '../Pages/Store/Login/Otp';
import ResetPassword from '../Pages/Store/Login/ResetPassword';
import Item from '../Pages/Store/Item/Item';
import ManageItem from '../Pages/Store/Item/ManageItem';
import GenMaster from '../Pages/Store/StoreMaster/GenMaster/GenMaster';
import ManageGenMaster from '../Pages/Store/StoreMaster/GenMaster/ManageGenMaster';

import EditProfile from '../Pages/Store/Profile/EditProfile';

import ScheduleList from '../Pages/Store/StoreMaster/Schedule/ScheduleList';
import ManageSchedule from '../Pages/Store/StoreMaster/Schedule/ManageSchedule';
import ClassList from '../Pages/Store/StoreMaster/Class/ClassList';
import ManageClass from '../Pages/Store/StoreMaster/Class/ManageClass';
import MocList from '../Pages/Store/StoreMaster/MocMaster/MocList';
import ManageMoc from '../Pages/Store/StoreMaster/MocMaster/ManageMoc';

import DrawingList from '../Pages/Store/StoreMaster/Drawing/DrawingList';
import ViewDrawing from '../Pages/Store/StoreMaster/Drawing/ViewDrawing';
import PurRequestList from '../Pages/Store/Prosafe/Transaction/PurchaseRequest/PurRequestList';
import ManagePurRequest from '../Pages/Store/Prosafe/Transaction/PurchaseRequest/ManagePurRequest';
import ViewPurRequest from '../Pages/Store/Prosafe/Transaction/PurchaseRequest/ViewPurRequest';
import PurOrderList from '../Pages/Store/Prosafe/Transaction/PurchaseOrder/PurOrderList';
import ManagePurOrder from '../Pages/Store/Prosafe/Transaction/PurchaseOrder/ManagePurOrder';
import ViewPurOrder from '../Pages/Store/Prosafe/Transaction/PurchaseOrder/ViewPurOrder';
import PurReceiveList from '../Pages/Store/Prosafe/Transaction/PurchaseReceive/PurReceiveList';
import ManagePurReceive from '../Pages/Store/Prosafe/Transaction/PurchaseReceive/ManagePurReceive';
import ViewPurReceive from '../Pages/Store/Prosafe/Transaction/PurchaseReceive/ViewPurReceive';
import ViewPurReturn from '../Pages/Store/Prosafe/Transaction/PurchaseReturn/ViewPurReturn';
import PurReturnList from '../Pages/Store/Prosafe/Transaction/PurchaseReturn/PurReturnList';
import ManagePurReturn from '../Pages/Store/Prosafe/Transaction/PurchaseReturn/ManagePurReturn';
import IssList from '../Pages/Store/Prosafe/Transaction/ProIssue/IssList';
import ManageIss from '../Pages/Store/Prosafe/Transaction/ProIssue/ManageIss';
import ViewIss from '../Pages/Store/Prosafe/Transaction/ProIssue/ViewIss';
import IssReturnList from '../Pages/Store/Prosafe/Transaction/ProIssueReturn/IssReturnList';
import ManageIssReturn from '../Pages/Store/Prosafe/Transaction/ProIssueReturn/ManageIssReturn';
import ViewIssReturn from '../Pages/Store/Prosafe/Transaction/ProIssueReturn/ViewIssReturn';
import ScrapList from '../Pages/Store/Prosafe/Transaction/Scrap/ScrapList';
import ManageScrap from '../Pages/Store/Prosafe/Transaction/Scrap/ManageScrap';
import ViewScrap from '../Pages/Store/Prosafe/Transaction/Scrap/ViewScrap';
import ProStockList from '../Pages/Store/Prosafe/ProStock/ProStockList';
import ProReOrder from '../Pages/Store/Prosafe/ProReports/ProReOrder';
import ProPoPending from '../Pages/Store/Prosafe/ProReports/ProPoPending';
import OtherIssList from '../Pages/Store/Prosafe/Transaction/OtherIss/OtherIssList';
import ManageOtherIss from '../Pages/Store/Prosafe/Transaction/OtherIss/ManageOtherIss';
import ViewOtherIss from '../Pages/Store/Prosafe/Transaction/OtherIss/ViewOtherIss';
import OtherPurList from '../Pages/Store/Prosafe/Transaction/OtherPurchase/OtherPurList';
import ManageOtherPur from '../Pages/Store/Prosafe/Transaction/OtherPurchase/ManageOtherPur';
import ViewOtherPur from '../Pages/Store/Prosafe/Transaction/OtherPurchase/ViewOtherPur';
import ProItemLedger from '../Pages/Store/Prosafe/ProReports/ProItemLedger';
import ManagePayment from '../Pages/Store/StoreMaster/PaymentMethod/ManagePayment';
import PaymentList from '../Pages/Store/StoreMaster/PaymentMethod/PaymentList';
import ManageItemCompany from '../Pages/Store/StoreMaster/ItemCompany/ManageItemCompany';
import ItemCompanyList from '../Pages/Store/StoreMaster/ItemCompany/ItemCompanyList';
import ProStockPlatList from '../Pages/Store/Prosafe/ProStorePlat/ProStockPlatList';
import DeliveryChallanList from '../Pages/Store/Prosafe/Transaction/Challan/DeliveryChallanList';
import ManageDeliveryChallan from '../Pages/Store/Prosafe/Transaction/Challan/ManageDeliveryChallan';
import ViewDeliveryChallan from '../Pages/Store/Prosafe/Transaction/Challan/ViewDeliveryChallan';
import StoreQuotationList from '../Pages/Store/storeQuotation/StoreQuotationList';
import ManageStoreQuotation from '../Pages/Store/storeQuotation/ManageStoreQuotation';
import AmendPurOrder from '../Pages/Store/Prosafe/Transaction/PurchaseOrder/AmendPurOrder';
import StockWithValueList from '../Pages/Store/Prosafe/StockWithValue/StockWithValueList';

const Store = () => {

  return (
    <>
      <Routes>
        <Route path="/user/login" element={<Login />} />

        <Route path='/user/forget-password' element={<ForgetPassword />} />
        <Route path='/user/otp-verification' element={<Otp />} />
        <Route path='/user/reset-password' element={<ResetPassword />} />
        <Route path='/user/edit-profile' element={<EditProfile />} />
        <Route path='/main-store/user/dashboard' element={<Dashboard />} />

        {/* Unit */}
        <Route path='/main-store/user/unit-management' element={<Unit />} />
        <Route path='/main-store/user/manage-unit' element={<ManageUnit />} />

        {/* Category */}
        <Route path='/main-store/user/category-management' element={<Category />} />
        <Route path='/main-store/user/manage-category' element={<ManageCategory />} />

        {/* Item Company  */}
        <Route path='/main-store/user/item-company-management' element={<ItemCompanyList />} />
        <Route path='/main-store/user/manage-item-company' element={<ManageItemCompany />} />


        {/* Transport */}
        <Route path='/main-store/user/transport-management' element={<Transport />} />
        <Route path='/main-store/user/manage-transport' element={<ManageTransport />} />

        {/* Payment Method  */}
        <Route path='/main-store/user/payment-management' element={<PaymentList />} />
        <Route path='/main-store/user/manage-payment-method' element={<ManagePayment />} />

        {/* Inventory Location */}
        <Route path='/main-store/user/inventory-location-management' element={<Location />} />
        <Route path='/main-store/user/manage-inventory-location' element={<ManageLocation />} />

        {/* Party */}
        <Route path='/main-store/user/party-management' element={<Party />} />
        <Route path='/main-store/user/manage-party' element={<ManageParty />} />

        {/* Project */}
        <Route path='/main-store/user/project-management' element={<Project />} />
        <Route path='/main-store/user/manage-project' element={<ManageProject />} />

        {/* Party Group */}
        <Route path='/main-store/user/party-group-management' element={<PartyGroup />} />
        <Route path='/main-store/user/manage-party-group' element={<ManagePartyGroup />} />

        {/* Stock */}
        {/* <Route path='/main-store/user/stock-management' element={<Stock />} /> */}
        {/* <Route path='/main-store/user/manage-stock' element={<ManageStock />} /> */}

        {/* store quotation  */}
        <Route path='/main-store/user/store-quotation' element={<StoreQuotationList />} />
        <Route path='/main-store/user/manage-store-quotation' element={<ManageStoreQuotation />} />

        {/* Item */}
        <Route path='/main-store/user/item-management' element={<Item />} />
        <Route path='/main-store/user/manage-item' element={<ManageItem />} />

        <Route path='/main-store/user/general-master-management' element={<GenMaster />} />
        <Route path='/main-store/user/manage-general-master' element={<ManageGenMaster />} />

        {/* Schedule */}
        <Route path='/main-store/user/schedule-management' element={<ScheduleList />} />
        <Route path='/main-store/user/manage-schedule' element={<ManageSchedule />} />

        {/* Class */}
        <Route path='/main-store/user/class-management' element={<ClassList />} />
        <Route path='/main-store/user/manage-class' element={<ManageClass />} />

        {/* MOC */}
        <Route path='/main-store/user/moc-management' element={<MocList />} />
        <Route path='/main-store/user/manage-moc' element={<ManageMoc />} />

        {/* Drawing */}
        <Route path="/main-store/user/drawing-management" element={<DrawingList />} />
        <Route path="/main-store/user/view-drawing" element={<ViewDrawing />} />

        {/* Purchase Request */}
        <Route path="/main-store/user/purchase-request-management" element={<PurRequestList />} />
        <Route path="/main-store/user/manage-purchase-request" element={<ManagePurRequest />} />
        <Route path="/main-store/user/view-purchase-request" element={<ViewPurRequest />} />

        {/* Purchase Request */}
        <Route path="/main-store/user/purchase-order-management" element={<PurOrderList />} />
        <Route path="/main-store/user/manage-purchase-order" element={<ManagePurOrder />} />
        <Route path="/main-store/user/view-purchase-order" element={<ViewPurOrder />} />
        <Route path="/main-store/user/amend-purchase-order" element={<AmendPurOrder />} />

        {/* Purchase Receive */}
        <Route path="/main-store/user/purchase-receive-management" element={<PurReceiveList />} />
        <Route path="/main-store/user/manage-purchase-receive" element={<ManagePurReceive />} />
        <Route path="/main-store/user/view-purchase-receive" element={<ViewPurReceive />} />

        {/* Purchase Receive */}
        <Route path='/main-store/user/purchase-return-management' element={<PurReturnList />} />
        <Route path='/main-store/user/manage-purchase-return' element={<ManagePurReturn />} />
        <Route path='/main-store/user/view-purchase-return' element={<ViewPurReturn />} />

        {/* Issue */}
        <Route path='/main-store/user/issue-management' element={<IssList />} />
        <Route path='/main-store/user/manage-issue' element={<ManageIss />} />
        <Route path='/main-store/user/view-issue' element={<ViewIss />} />

        {/* Issue Return */}
        <Route path='/main-store/user/issue-return-management' element={<IssReturnList />} />
        <Route path='/main-store/user/manage-issue-return' element={<ManageIssReturn />} />
        <Route path='/main-store/user/view-issue-return' element={<ViewIssReturn />} />

        {/* Scrap */}
        <Route path='/main-store/user/scrap-management' element={<ScrapList />} />
        <Route path='/main-store/user/manage-scrap' element={<ManageScrap />} />
        <Route path='/main-store/user/view-scrap' element={<ViewScrap />} />

        {/* Delivery Challan */}
        <Route path='/main-store/user/delivery-challan-management' element={<DeliveryChallanList />} />
        <Route path='/main-store/user/manage-delivery-challan' element={<ManageDeliveryChallan />} />
        <Route path='/main-store/user/view-delivery-challan' element={<ViewDeliveryChallan />} />

        {/* Other Issue */}
        <Route path='/main-store/user/other-issue-management' element={<OtherIssList />} />
        <Route path='/main-store/user/manage-other-issue' element={<ManageOtherIss />} />
        <Route path='/main-store/user/view-other-issue' element={<ViewOtherIss />} />

        {/* Other Purchase */}
        <Route path='/main-store/user/other-purchase-management' element={<OtherPurList />} />
        <Route path='/main-store/user/manage-other-purchase' element={<ManageOtherPur />} />
        <Route path='/main-store/user/view-other-purchase' element={<ViewOtherPur />} />

        {/* Stock */}
        <Route path='/main-store/user/stock-management' element={<ProStockList />} />

        <Route path='/main-store/user/stock-with-value-management' element={<StockWithValueList />} />

        {/* stock plat  */}
        <Route path='/main-store/user/stock-plat-management' element={<ProStockPlatList />} />

        {/* Report */}
        <Route path='/main-store/user/reorder-items' element={<ProReOrder />} />
        <Route path='/main-store/user/po-pending-management' element={<ProPoPending />} />
        <Route path='/main-store/user/item-ledger' element={<ProItemLedger />} />

        < Route path='/main-store/user/*' element={<Navigate to='/main-store/user/dashboard' />} />
      </Routes>
    </>
  )
}

export default Store